export const stringArrayToPostgresTextArray = (arr: string[]) => {
  return `{${arr.join(", ")}}`;
};
